module.exports = __webpack_public_path__ + "img/bar-all-active.1d043e98.svg";